import React from 'react';

import ReactECharts from 'echarts-for-react';

import { INGESTION_COLORS, buildChartTheme } from './chartTheme';

import useLaptopCompact from './useLaptopCompact';

import ChartEmptyState from './ChartEmptyState';

import DonutChartFrame from './DonutChartFrame';



const CompactDonutChart = ({

  data,

  compact = false,

  colorPalette = INGESTION_COLORS,

  renderZeroWhenEmpty = false,

  emptyStateTitle = 'No activity for this period',

  emptyStateSubtitle = 'Try changing the time filter.',

  emptyStateCompact,

}) => {

  const isLaptopCompact = useLaptopCompact();

  const theme = buildChartTheme(isLaptopCompact);



  const hasTypes = Array.isArray(data?.types) && data.types.length > 0;

  if (!hasTypes && !renderZeroWhenEmpty) {

    return (

      <ChartEmptyState

        title={emptyStateTitle}

        subtitle={emptyStateSubtitle}

        compact={emptyStateCompact ?? compact}

      />

    );

  }



  const normalizedData = hasTypes

    ? data

    : {

        total: 0,

        types: [

          { name: 'Instant Run', value: 0, percent: 0 },

          { name: 'One-time Schedule', value: 0, percent: 0 },

          { name: 'Recurring Schedule', value: 0, percent: 0 },

        ],

      };



  const chartData = normalizedData.types.map((t, i) => ({

    name: t.name,

    value: t.value ?? Math.round((normalizedData.total * (t.percent ?? 0)) / 100),

    itemStyle: { color: colorPalette[i % colorPalette.length] },

  }));



  const centerFontSize = theme.fs(compact ? 18 : 20);

  const centerLineHeight = isLaptopCompact ? 22 : 24;

  const donutCenter = ['50%', compact ? '44%' : '46%'];

  const baseHeight = compact ? 240 : 280;

  const chartHeight = isLaptopCompact ? Math.round(baseHeight * 0.94) : baseHeight;



  const options = {

    animation: false,

    tooltip: {

      ...theme.tooltipBase,

      trigger: 'item',

      formatter: (p) => `${p.name}: ${p.percent}%`,

    },

    legend: {

      ...theme.legendBase,

      bottom: compact ? 0 : 8,

      left: 'center',

      orient: 'horizontal',

      formatter: (name) => {

        const item = normalizedData.types.find((t) => t.name === name);

        return item ? `${name} — ${item.percent}%` : name;

      },

    },

    series: [{

      type: 'pie',

      radius: compact ? ['48%', '70%'] : ['45%', '68%'],

      center: donutCenter,

      label: { show: false },

      labelLine: { show: false },

      data: chartData,

    }],

  };



  return (

    <DonutChartFrame

      center={donutCenter}

      centerLabel={`${normalizedData.total}\nRUNS`}

      centerStyle={{ fontSize: centerFontSize, lineHeight: `${centerLineHeight}px` }}

      height={`${chartHeight}px`}

    >

      <ReactECharts

        option={options}

        style={{ height: `${chartHeight}px`, width: '100%' }}

        opts={{ renderer: 'canvas' }}

      />

    </DonutChartFrame>

  );

};



export default CompactDonutChart;

